export default class SkipToContentAction
{
    static get name() { return "SKIP_TO_CONTENT"; }

    static createAction(settings)
    {
        return {
            type: this.name,
            payload:
            {
                stateLocation: `${settings.stateLocations.Window.SkipToContent.Base}.${settings.stateLocations.Window.SkipToContent.ShouldSkipToContent}`,
                value: true
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-skip-to-content/src/actions/skipToContentAction.js